<template>
    <section class="list-delivery-detail">
        <DeliveryDetailItem
            v-for="( deliveryItem, index ) in mailItemList"
            :key="index"
            :mailItem="deliveryItem"
            class="delivery-detail"
        />
    </section>
</template>

<script>
// Components
import DeliveryDetailItem from './listDeliveryDetail/DeliveryDetailItem';

export default {
    name: 'ListDeliveryDetail',
    components: {
        DeliveryDetailItem,
    },
    props: {
        mailItemList: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss">

.list-delivery-detail {
    box-shadow: inset 0 1px 3px #dbdbdb;
    background: $colors-grey-lighten-5;
    padding: 1rem;

    >*:not(:last-child) {
        margin-bottom: 1rem;
    }
}

.delivery-detail {
    //
}

@include mixins-above(tablet) {
    //
}
</style>
